import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";

const PrivacyFirstBanner = () => (
  <div className="w-full border-b border-border/60 bg-secondary/40">
    <div className="container flex items-center justify-center gap-2 py-2 text-xs sm:text-sm text-secondary-foreground text-center">
      <ShieldCheck className="h-4 w-4 shrink-0 text-primary" aria-hidden="true" />
      <p>
        <span className="font-semibold">Privacy-first website:</span>{" "}
        We do not use tracking cookies, advertising pixels, or third-party analytics on this site.{" "}
        <Link to="/privacy-policy" className="underline hover:text-primary">
          Read our Privacy Notice
        </Link>
        .
      </p>
    </div>
  </div>
);

export default PrivacyFirstBanner;
